import { getRenderingEngines } from '../RenderingEngine/getRenderingEngine';
import { viewportSupportsVolumeId, } from './viewportCapabilities';
function getViewportsWithVolumeId(volumeId) {
    const renderingEngines = getRenderingEngines();
    const targetViewports = [];
    renderingEngines.forEach((renderingEngine) => {
        const viewports = renderingEngine
            .getViewports()
            .filter(viewportSupportsVolumeId);
        const filteredViewports = viewports.filter((vp) => vp.hasVolumeId(volumeId));
        targetViewports.push(...filteredViewports);
    });
    return targetViewports;
}
export default getViewportsWithVolumeId;
